import { api, buildQueryString } from '../core';

export interface BundleGetDownloadIndexResponse {
  downloadPath: string;
  downloadToken: string;
}

type BundleGetDownloadIndexProps = {
  bundleId: string;
  /** Custom INDEX template to apply. Omit for the default index template. */
  templateId?: string;
};

export const getBundleGetDownloadIndexApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleGetDownloadIndex: builder.query<BundleGetDownloadIndexResponse, BundleGetDownloadIndexProps>({
      query: (params: BundleGetDownloadIndexProps) => {
        const queryString = buildQueryString(params, { bundleId: 'bundle_id', templateId: 'template_id' });

        return {
          url: `bundle/get-download/index?${queryString}`,
          method: 'GET',
        };
      },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundleGetDownloadIndexQuery } = getBundleGetDownloadIndexApi;
